///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-security.ts"/>
///<reference path="../../../common/security.keys.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../filter-templates/logged-in-employee-only.filter.ts"/>
///<reference path="../collections/report-employees.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    export class SalesRankingEmployeeDataTemplate extends ReportEmployeeWitchCategoriesDataTemplate implements ISecureDataTemplate {

        get leafCollection() {
            return this.collection;
        }
    }
}
